import { createContext } from 'react';

import { type EnnismoreAPIClientCompositeConfig } from '../interfaces';

export const EnnismoreAPIClientConfigContext =
  createContext<EnnismoreAPIClientCompositeConfig | null>(null);
